var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileImagePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.09 20.5H6L12 14.5L13.88 16.38C14.5 15.4 15.36 14.6 16.4 14.1L18 12.5V13.59C18.33 13.54 18.66 13.5 19 13.5C19.34 13.5 19.67 13.54 20 13.59V8.5L14 2.5H6C4.89 2.5 4 3.39 4 4.5V20.5C4 21.0304 4.21071 21.5391 4.58579 21.9142C4.96086 22.2893 5.46957 22.5 6 22.5H13.81C13.46 21.89 13.21 21.22 13.09 20.5ZM13 4L18.5 9.5H13V4ZM8 9.5C8.53043 9.5 9.03914 9.71071 9.41421 10.0858C9.78929 10.4609 10 10.9696 10 11.5C10 12.0304 9.78929 12.5391 9.41421 12.9142C9.03914 13.2893 8.53043 13.5 8 13.5C6.89 13.5 6 12.61 6 11.5C6 10.39 6.9 9.5 8 9.5ZM20 15.5V18.5H23V20.5H20V23.5H18V20.5H15V18.5H18V15.5H20Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImagePlus);
export default __webpack_public_path__ + "static/media/file_image_plus.d0ec8254ad25b1b23e97dabdd9c5d985.svg";
export { ForwardRef as ReactComponent };